import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { stringify } from '../../../common/util/stringify';
/**
 * Represents an uncaught non Error type error. This class does
 * not extend the Error class to prevent an invalid stack trace
 * from being created. Use this class to cast thrown errors that
 * do not use the Error class (strings, etc) to an object.
 */

export var UncaughtError = /*#__PURE__*/_createClass(function UncaughtError(message, filename, lineno, colno, newrelic) {
  _classCallCheck(this, UncaughtError);

  this.name = 'UncaughtError';
  this.message = typeof message === 'string' ? message : stringify(message);
  this.sourceURL = filename;
  this.line = lineno;
  this.column = colno;
  this.__newrelic = newrelic;
});